import React, { Children } from 'react';
import searchFields from '../search-fields';
import { Inputs } from '../../../../../Components';
import { PerformanceInsightsTranslationPath } from '../../i18n/PerformanceInsightsLocale';
import { useTranslation } from 'react-i18next';
import { PropertyComponent } from './PropertyComponent';


const SearchFields = ({ onSearchHandler, params }) => {
  const { t } = useTranslation(PerformanceInsightsTranslationPath);
  return (
    <>
      {Children.toArray(
        searchFields.map((item) => {
          if (item.componentType === 'autocomplete' && item.component === 'PropertyComponent') {
            return (
              <PropertyComponent
                parentTranslationPath={PerformanceInsightsTranslationPath}
                translationPath=""
                onInputChanged={(e) => onSearchHandler(e, item.searchKey)}
                state={{ rotationSchemeProperties: params.rotationSchemeProperties || [] }}
              />
            );
          }
          return (
            <Inputs
              inputPlaceholder={t(item.label)}
              parentTranslationPath={PerformanceInsightsTranslationPath}
              onInputChanged={(e) => onSearchHandler(e, item.searchKey)}
            />
          );
        })
      )}
    </>
  );
};

export default SearchFields;